/**
 * @file ReturnButton.tsx
 * @description
 * -----------------------------------------------------
 * Botón para volver a la vista de Infrastructura
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-06-02
 * @modified 2026-02-25
 * @author DLTCode
 * @author Ismael Benabdellah
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { useRouter } from "@/features/i18n";
import { Undo2Icon } from "lucide-react";
import ButtonComponent from "./ButtonComponent";
export type ReturnButtonProps = {
  href: Parameters<ReturnType<typeof useRouter>["replace"]>[0];
  options?: Parameters<ReturnType<typeof useRouter>["replace"]>[1];
};
const ReturnButton = t0 => {
  const $ = _c(9);
  const {
    href,
    options
  } = t0;
  const t = useTranslations("Buttons");
  const router = useRouter();
  let t1;
  if ($[0] !== t) {
    t1 = t("buttonBack");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const accessibleLabel = t1;
  let t2;
  if ($[2] !== href || $[3] !== options || $[4] !== router) {
    t2 = () => {
      if (window.history.length > 1) {
        router.back();
      } else {
        router.replace(href, options);
      }
    };
    $[2] = href;
    $[3] = options;
    $[4] = router;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleReturn = t2;
  let t3;
  if ($[6] !== accessibleLabel || $[7] !== handleReturn) {
    t3 = <ButtonComponent icon={Undo2Icon} onClick={handleReturn} className="btn btn--back " aria-label={accessibleLabel} title={accessibleLabel} />;
    $[6] = accessibleLabel;
    $[7] = handleReturn;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default ReturnButton;